/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 */

function customInit() {
  langSwitcherInit();
  //detectCountryInit();

  sectionCartInit();

  technicalDataInit();

  snippetSlideshowInit();

  outOfStockFixInit();

  slideshowNavScrollerChangeDetectorInit();

  fixProductWrapperHeight();
}

var countriesWithoutFreeShipping = ["AF","DZ","AO","AI","AG","AR","AW","AZ","BS","BH","BD","BB","BZ","BJ","BM","BT","BO","BW","BR","IO","VG","BN","BF","BI","KH","CM","CV","BQ","KY","CF","TD","CL","CX","CC","CO","KM","CG","CD","CK","CR","CU","CW","CI","DJ","DM","DO","EC","SV","GQ","ER","SZ","ET","FK","FJ","GF","PF","TF","GA","GM","GH","GD","GT","GQ","GW","GY","HT","HM","HN","IN","IR","IQ","JM","JO","KZ","KE","KI","KW","KG","LA","LB","LS","LR","LY","MO","MG","MW","MV","ML","MQ","MR","MU","MN","MS","MZ","MM","NA","NR","NP","NC","NI","NE","NG","NU","NF","KP","OM","PK","PA","PG","PY","PE","PH","RU","RW","AS","ST","SA","SN","SC","SL","SX","SB","SO","GS","SS","BL","SH","KN","LC","MF","PM","VC","SS","SR","SY","TJ","TZ","TL","TG","TK","TO","TT","TN","TM","TC","TV","UM","UG","UY","UZ","VU","VE","VN","WF","EH","YE","ZM","ZW"];

document.addEventListener('variant:changed', function(event) {
  customOnVariantChange(event.detail.variant);
});

/* Lang switcher */
function langSwitcherInit() {
  var shopLang = 'en';
  var langMap = {
    de: 'https://www.sternglas.de',
    en: 'https://www.sternglas.com',
  };
  var langSelects = document.querySelectorAll('.sg__lang-switcher select');
  var langSwitcherImages = document.querySelectorAll('.sg__lang-switcher img');
  langSelects.forEach( function (item) {
    item.value = shopLang;
    item.addEventListener('change', function (event) {
      var selectedLang = event.srcElement && event.srcElement.value;
      if (selectedLang === shopLang) {
        return;
      }
      var url = langMap[selectedLang];
      if (!url) {
        return;
      }
      langSwitcherImages.forEach(function (img) { img.style.display = 'none'; });
      location.href = url;
    });
  });
}

/* Sections */
/** Cart **/
function sectionCartInit() {
  var checkoutButton = document.querySelector('.Cart__Checkout.Button');
  var checkoutButtonHint = document.querySelector('.Cart__Checkout-Hint');
  var agbInput = document.querySelector('.Cart__Legal-agb input');
  if (agbInput && checkoutButton) {
    agbInput.addEventListener('change', function () {
      checkoutButton.disabled = !agbInput.checked;
      if (checkoutButtonHint) {
        checkoutButtonHint.style.display = checkoutButton.disabled ? 'block' : 'none';
      }
    });
    agbInput.dispatchEvent(new Event('change'));
  }

  function onDiscountEntry(event) {
    if (!!event.target.value) {
      event.target.parentNode.classList.add('field--show-floating-label');
    } else {
      event.target.parentNode.classList.remove('field--show-floating-label');
    }
  }
  var discountField = document.querySelector('.sg-discount-field .field__input');
  if (discountField) {
    discountField.onkeyup=onDiscountEntry;
  }

}

/** Product **/
function technicalDataInit() {
  var groups = {
    clockwork: {
      button: document.querySelector('.sg__technical-data--switches .Button--clockwork'),
      list: document.querySelector('.sg__technical-data--clockwork'),
    },
    design: {
      button: document.querySelector('.sg__technical-data--switches .Button--design'),
      list: document.querySelector('.sg__technical-data--design'),
    }
  }
  if (groups.clockwork.button && groups.design.button) {
    groups.clockwork.button.addEventListener('click', function () { showTechnicalData(groups.clockwork, groups.design); });
    groups.design.button.addEventListener('click', function () { showTechnicalData(groups.design, groups.clockwork); });
  }

  function showTechnicalData(newGroup, oldGroup) {
    if (hasClass(newGroup.button, 'active')) {
      return;
    }
    removeClass(oldGroup.button, 'active');
    addClass(newGroup.button, 'active');

    removeClass(newGroup.list, 'hidden');
    addClass(oldGroup.list, 'hidden');
  }
}

function customOnVariantChange(variant)
{
  window.esc_now_back_in_stock && window.esc_now_back_in_stock.triggerRefresh && window.esc_now_back_in_stock.triggerRefresh();
  fixProductWrapperHeight();
  if (variant.available) {
    $('.hide-when-variant-unavailable').removeClass('hidden');
  } else {
    $('.hide-when-variant-unavailable').addClass('hidden');
  }
}

/** OutOfStock App Fix **/
function outOfStockFixInit() {
  var outOfStockForm = document.getElementById('esc-oos-form');
  if (!outOfStockForm)
    return;

  var mutationObserver = new MutationObserver(function(mutations) {
    mutations.forEach(function(mutation) {
      setTimeout(fixProductWrapperHeight, 100);
    });
  });

  mutationObserver.observe(outOfStockForm, {
    attributes: false,
    characterData: false,
    childList: true,
    subtree: false,
    attributeOldValue: false,
    characterDataOldValue: false
  });
}

/** Variant App Fix **/
function slideshowNavScrollerChangeDetectorInit() {
  var mutationObserver = new MutationObserver(function(mutations) {
    mutations.forEach(function(mutation) {
      if (mutation.type === 'childList') {
        snippetSlideshowInit();
      }
    });
  });
  var slideshowNavScroller = document.querySelector('.Product__SlideshowNavScroller');
  if (!slideshowNavScroller)
    return;

  mutationObserver.observe(slideshowNavScroller, {
    attributes: false,
    characterData: false,
    childList: true,
    subtree: true,
    attributeOldValue: false,
    characterDataOldValue: false
  });
}

/* Snippets */
/** Slideshow **/
function snippetSlideshowInit() {
  var thumbnails = document.querySelectorAll('.Product__SlideshowNavImage'), i;
  for (i = 0; i < thumbnails.length; ++i) {
  	thumbnails[i].onclick = selectSlideshowImageFn(thumbnails[i].getAttribute('href'));
  }
}

function selectSlideshowImageFn(id) {
  return function () {
    var selectedEl = document.querySelector('.Product__SlideItem.is-selected');
    if (!!selectedEl) {
      removeClass(selectedEl, 'is-selected');
    }
    var el = document.querySelector(id);
    if (!hasClass(el, 'is-selected')) {
      addClass(el, 'is-selected');
    }
  }
}
/*
function detectCountryInit() {
  var apiKey = '22c79cd7d2cd9eb194a40e2b2a67dd607e05a01493e80da257e5fcd9';
  var cacheKey = 'sg_current_country';

  var currentCountryJson = localStorage.getItem(cacheKey);
  if (!currentCountryJson) {
    $.getJSON('https://api.ipdata.co?api-key=' + apiKey + '&fields=country_name,country_code')
   	.then(function (response) {
      localStorage.setItem(cacheKey, JSON.stringify(response));
      applyCountry(response);
    })
    .catch(function (error) {
      console.warn('No country detection possible', error);
      applyCountry({
        country_code: null,
        country_name: 'your country',
      });
    })
  } else {
    applyCountry(JSON.parse(currentCountryJson));
  }
}

function applyCountry(country) {
  //applyCountryFlag(country.country_code);
  $('.inject-country-emoji').text(getFlagEmoji(country.country_code));
  $('.inject-country-name').text(country.country_name);
  validateCountry(country);

  // Apply US patches
  if(country.country_code == "US"){
    var announcement = document.querySelector(".AnnouncementBar .AnnouncementBar__Content:nth-child(2)")
    var announcement_link = "/pages/retailer-locator";

    if(announcement_link){
      announcement.innerHTML = '<a href="'+announcement_link+'" style="text-decoration:underline">Free DHL express shipping over 100€ +26 retail locations in the US</a>';
    } else {
      announcement.innerHTML = "Free DHL express shipping over 100€ +26 retail locations in the US";
    }

    var shipping_info = document.querySelector(".container_extra-info > .shipping-info");

    if(!shipping_info) return;
    announcement_link = "" || announcement_link;
    var us_exclusive_info = document.createElement(announcement_link ? "a":"div")

    us_exclusive_info.innerHTML = "+26 retail locations in US" || "Free DHL express shipping over 100€ +26 retail locations in the US";
    us_exclusive_info.classList.add("us-extra-info");

    if(announcement_link){
      us_exclusive_info.href = announcement_link;
    }

    shipping_info.after(us_exclusive_info)

  }
}
function getFlagEmoji(countryCode) {
  const codePoints = countryCode
    .toUpperCase()
    .split('')
    .map(char =>  127397 + char.charCodeAt());
  return String.fromCodePoint(...codePoints);
}

function applyCountryFlag(country_code) {
  console.log("hi");
  $('.inject-country-flag').attr(
      'src',
      'https://intgepi.bglobale.com/content/images/flags/' +
          country_code.toLowerCase() +
          '.png'
  );
  $('.inject-country-flag').removeClass('hidden');

}


function validateCountry(country) {
  if (countriesWithoutFreeShipping.indexOf(country.country_code) !== -1) {
    $('.show-if-unsupported-country').removeClass('hidden');
    $('.hide-if-unsupported-country').addClass('hidden');
  }
}
*/

/* Helpers */

function fixProductWrapperHeight() {
  var productWrapperElement = document.querySelector('.Product__Wrapper');
  if (!productWrapperElement)
    return;
  var productInfoElement = document.querySelector('.Product__Info');
  if (!productInfoElement)
    return;
  var computedStyle = window.getComputedStyle(productInfoElement);
  productWrapperElement.style.minHeight = productInfoElement.scrollHeight - parseInt(computedStyle.paddingTop) - 100 + 'px';
}

function hasClass(el, className) {
  return el.classList ? el.classList.contains(className) : new RegExp('\\b'+ className+'\\b').test(el.className);
}

function addClass(el, className) {
  if (el.classList) el.classList.add(className);
  else if (!hasClass(el, className)) el.className += ' ' + className;
}

function removeClass(el, className) {
  if (el.classList) el.classList.remove(className);
  else el.className = el.className.replace(new RegExp('\\b'+ className+'\\b', 'g'), '');
}
window.onload = function () { customInit(); };